import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  download: {
    id: 'studio.5q3qC0',
    defaultMessage: 'Download',
  },
  notSupported: {
    id: 'studio.ZW/7f6',
    defaultMessage: 'This asset can not be previewed.',
  },
});
